(function () {
    "use strict";

    class Popup {
        constructor($rootScope, $compile, $window, callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText) {
            this._$rootScope = $rootScope;
            this._$compile = $compile;
            this._callbackOk = callbackOk;
            this._callbackCancel = callbackCancel;
            this._text = text;
            this._dataObjectToIncludeInResult = dataObjectToIncludeInResult;
            this._btnOkText = btnOkText;
            this._btnCancelText = btnCancelText;
            this._$window = $window;
        }

        get okButtonLabel() {
            if (!this._btnOkText) this._btnOkText = this._$rootScope.translations.SO_ClearanceWillExpire_button_ok;
            return `<i class= "fa fa-check"></i> ${this._btnOkText}`;
        }

        get cancelButtonLabel() {
            if (!this._btnCancelText) this._btnCancelText = this._$rootScope.translations.Shared_Continue;
            return `<i class= "fa fa-check"></i> ${this._btnCancelText}`;
        }

        getOptions() {
            const options = {
                onEscape: false,
                closeButton: false,
                size: 'large',
                message: this._$compile('<popup options="popupOptions"></popup>')(this._$rootScope),
                blockingPriority: 1,
            };
            return options;
        }
    }

    class RestrictivePopup extends Popup {
        constructor($rootScope, $compile, $window, callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText) {
            super($rootScope, $compile, $window, callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText);
            this._$rootScope.popupOptions = { text: this._text, isRestrictive: true };
            this.options = this.getOptions();
            this.options.callback = () => callbackOk(dataObjectToIncludeInResult);
            this.options.buttons = { ok: { label: this.okButtonLabel } };
        }

        show() {
            return this._$window.bootbox.alert(this.options);
        }
    }

    class InfoPopup extends Popup {
        constructor($rootScope, $compile, $window, callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText) {
            super($rootScope, $compile, $window, callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText);
            this._$rootScope.popupOptions = { text: this._text, isDialog: false };
            this.options = this.getOptions();
            this.options.callback = (result) => {
                if (result) callbackOk(this._dataObjectToIncludeInResult);
                else if (angular.isFunction(callbackCancel)) callbackCancel(this._dataObjectToIncludeInResult);
            };

            this.options.buttons = {
                confirm: { label: this.okButtonLabel },
                cancel: { label: this.cancelButtonLabel }
            };
        }

        show() {
            return this._$window.bootbox.confirm(this.options);
        }
    }

    class InfoPopupNoCancel extends Popup {
        constructor($rootScope, $compile, $window, callbackOk, text, dataObjectToIncludeInResult, btnOkText) {
            super($rootScope, $compile, $window, callbackOk, null, text, dataObjectToIncludeInResult, btnOkText, null);
            this._$rootScope.popupOptions = { text: this._text, isDialog: false };
            this.options = this.getOptions();
            this.options.callback = () => callbackOk(dataObjectToIncludeInResult);
            this.options.buttons = {
                ok: { label: this.okButtonLabel },
            };
        }

        show() {
            return this._$window.bootbox.alert(this.options);
        }
    }

    class DialogPopup extends Popup {
        constructor($rootScope, $compile, $window, callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText, defaultText) {
            super($rootScope, $compile, $window, callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText);
            this._$rootScope.popupOptions = { text: this._text, isDialog: true, defaultText };
            this.options = this.getOptions();
            this.options.buttons = {
                confirm: {
                    label: this.okButtonLabel, callback: () => {
                        const textFromtxtArea = $('#txtArea').val();
                        callbackOk(textFromtxtArea, dataObjectToIncludeInResult);
                    }
                },
                cancel: { label: this.cancelButtonLabel, callback: () => callbackCancel(dataObjectToIncludeInResult) }
            };
        }

        show() {
            return this._$window.bootbox.dialog(this.options);
        }
    }

    angular.module('app').factory('popupFactory', PopupFactory);

    PopupFactory.$inject = ['$window', '$rootScope', '$compile'];
    /**
     * popupFactory supports 3 popups at the moment:
     * - informative: white, it is possible to click cancel and continue on screen
     * - dialog: white, with textarea, ok and cancel
     * - restrictive: red, not possible to click cancel.
     * - more to be added...
     * 
     * The popup itself is also returned
     * 
     * @param {any} $window
     * @param {any} $rootScope
     * @param {any} $compile
     * @returns popup
     */
    function PopupFactory($window, $rootScope, $compile) {
        return {
            GetRestrictivePopup: getRestrictivePopup,
            GetInfoPopup: getInfoPopup,
            GetInfoPopupNoCancel: getInfoPopupNoCancel,
            GetDialogPopup: getDialogPopup
        };

        function getRestrictivePopup(callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText) {
            const popup = new RestrictivePopup($rootScope, $compile, $window, callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText).show();
            return popup;
        }

        function getInfoPopup(callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText) {
            const popup = new InfoPopup($rootScope, $compile, $window, callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText);
            return popup.show();
        }

        function getInfoPopupNoCancel(callbackOk, text, dataObjectToIncludeInResult, btnOkText) {
            const popup = new InfoPopupNoCancel($rootScope, $compile, $window, callbackOk, text, dataObjectToIncludeInResult, btnOkText);
            return popup.show();
        }

        function getDialogPopup(callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText, defaultText) {
            const popup = new DialogPopup($rootScope, $compile, $window, callbackOk, callbackCancel, text, dataObjectToIncludeInResult, btnOkText, btnCancelText, defaultText);
            return popup.show();
        }
    }
})();
